import styled from '@emotion/styled';
import { differenceInMinutes } from 'date-fns';

import { StatsOverview } from './StatsOverview';
import { BarGraph } from './BarGraph';
import { convertTimeStringToDate, differenceInHours } from '../utils';
import { TOTAL_STUDY_MINUTES, getStudyTimeProgressPercentage } from './overviewUtils';

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 40px;
  padding: 0 32px 0 20px;
`;

type Props = {
  currentTime: Date;
  timeSaved: number;
};

export const TimeBackOverview = ({ currentTime, timeSaved }: Props) => {
  const startTime = convertTimeStringToDate('9:00 AM');

  const timeSpent = Math.max(
    Math.min(
      differenceInMinutes(currentTime, startTime, { roundingMethod: 'ceil' }),
      TOTAL_STUDY_MINUTES
    ),
    0
  );
  const timeRemaining = Math.max(TOTAL_STUDY_MINUTES - timeSpent - timeSaved, 0);

  const { timeSpentPercentage, timeSavedPercentage, timeRemainingPercentage } =
    getStudyTimeProgressPercentage({ timeSpent, timeSaved, timeRemaining });

  return (
    <Container>
      <StatsOverview
        timeSpent={differenceInHours(Math.max(timeSpent - timeSaved, 0))}
        timeSaved={differenceInHours(timeSaved)}
        timeRemaining={differenceInHours(timeRemaining)}
      />
      <BarGraph
        timeSpent={timeSpentPercentage}
        timeSaved={timeSavedPercentage}
        timeRemaining={timeRemainingPercentage}
      />
    </Container>
  );
};
